import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { processLink } from "../../utils/shortPinItem";

export const takePdfPasswordProtected = createAsyncThunk(
  "pdf/take-pdf-password-protected",
  async ({ formData, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/pdf/password-protected-try`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.status) {

        return response.data;
      } else {
        return rejectWithValue(response.data.message);
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Network error");
    }
  }
);

export const updatePdf = createAsyncThunk(
  "link/updatePdf",
  async ({ id, formData, token }, { rejectWithValue }) => {
    try {

      console.log(formData)
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/pdf/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200 && response.data.status) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error updating link");
    }
  }
);

export const PdfmoveInFolder = createAsyncThunk(
  "pdf/moveInFolder",
  async ({ token, folderId, id }, { rejectWithValue }) => {


    try {

      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/pdf/folders/move-in-folder`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            pdfId: id, folderId
          }
        }
      );

      if (response.data.status) {
        return { id, folderId, response: response.data.response };
      } else {
        return rejectWithValue("Failed to Add in folder");
      }
    } catch (error) {

      return rejectWithValue(
        error.response?.data || "Error to add in folder "
      );
    }
  }
);

export const getPdf = createAsyncThunk(
  "pdf/getByKey",
  async ({ token, key }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL_CRUD}/pdf/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response);
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        return rejectWithValue("Failed to fetch PDF");
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Network error");
    }
  }
);



export const deletePdf = createAsyncThunk(
  "pdf/deletepdf",
  async ({ id, token }, { rejectWithValue }) => {
    try {
      console.log(id);
      const response = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}/pdf/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status) {
        return ({ id: id, response: response.data.response })


      } else {
        return rejectWithValue("Failed to delete pdf");
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Network error");
    }
  }
);

export const takePdfLogged = createAsyncThunk(
  "pdf/take-pdf",
  async ({ formData, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/pdf/try`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.status) {
        toast.success("PDF captured successfully!");
        return response.data;
      } else {
        return rejectWithValue(response.data.message);
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Network error");
    }
  }
);

export const getPdfs = createAsyncThunk(
  "pdf/get-pdf",
  async ({ token, offset = 1, limit = 10, onlyMy }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/pdf/list`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: { offset, limit, onlyMy },
        }
      );
      if (response.data.status) {
        return response.data.response;
      } else {
        return rejectWithValue("Failed to load PDFs");
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Network error");
    }
  }
);

const initialState = {
  pdfData: [],
  isLoading: false,
  error: null,
};

const pdfSlice = createSlice({
  name: "pdf",
  initialState,
  reducers: {
    addPdf: (state, action) => {
      state.pdfData.unshift(action.payload)
    },
    removeFirstPdf: (state) => {
      state.pdfData.shift();
    },
    clearPdf: (state) => {
      state.pdfData = []
    },
    removeFromFolderPdf: (state, action) => {
      const pdf = state.pdfData.find(pdf => pdf.key === action.payload.key);
      if (pdf) {
        pdf.folderId = null;
      }
    },
    togglePinPdf: (state, action) => {
      const pin = state.pdfData.find(item => item.key === action.payload.key);
      if (pin) {
        pin.pin = !pin.pin;
      }

      state.pdfData = processLink(state.pdfData);

    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPdfs.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPdfs.fulfilled, (state, action) => {
        state.isLoading = false;

        const { offset } = action.meta.arg;

        if (offset === 1) {

          state.pdfData = processLink(action.payload);
        } else {

          const combined = [...state.pdfData, ...action.payload];
          const unique = Array.from(new Map(combined.map(pdf => [pdf.key, pdf])).values());
          state.pdfData = processLink(unique);
        }
        // toast.success("PDFs fetched successfully!");
      })
      .addCase(getPdfs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        // toast.error("Failed to get list of PDFs");
      })
      .addCase(takePdfLogged.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(takePdfLogged.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(takePdfLogged.rejected, (state, action) => {
        state.isLoading = false;
        toast.error(action.payload);
      })
      .addCase(getPdf.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPdf.fulfilled, (state, action) => {
        state.isLoading = false;
        state.pdfData = [action.payload];
        // toast.success("PDF fetched successfully!");
      })
      .addCase(getPdf.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        // toast.error("Failed to fetch PDF");
      })
      .addCase(deletePdf.pending, (state) => {
        state.isLoading = true
      })
      .addCase(deletePdf.fulfilled, (state, action) => {
        state.isLoading = false;

        state.pdfData = state.pdfData.filter(
          (pdf) => pdf.pdfId !== action.payload.id
        );
        toast.success(action.payload.response);
      })
      .addCase(deletePdf.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        toast.error(action.payload || "Failed to delete screenshot.");
      })
      .addCase(PdfmoveInFolder.pending, (state, action) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(PdfmoveInFolder.fulfilled, (state, action) => {
        state.isLoading = false
        const pdf = state.pdfData.find(pdf => pdf.pdfId === action.payload.id);
        if (pdf) {
          pdf.folderId = action.payload.folderId;

        }
        toast(action.payload.response)
      })
      .addCase(PdfmoveInFolder.rejected, (state, action) => {
        state.isLoading = false
        toast(action.payload)
      })
      .addCase(updatePdf.pending, (state, action) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(updatePdf.fulfilled, (state, action) => {
        state.isLoading = false
        toast.success(action.payload.response)
      })
      .addCase(updatePdf.rejected, (state, action) => {
        state.isLoading = false
        toast(action.payload)
        toast.error(action.payload)
      })
      .addCase(takePdfPasswordProtected.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(takePdfPasswordProtected.fulfilled, (state) => {
        state.isLoading = false;
        state.error = null;
        toast.success("PDF Generated Successfully!");
      }).addCase(takePdfPasswordProtected.rejected, (state) => {
        state.isLoading = false;
        state.error = null;
        toast.error("Failed to process PDF try again later.");
      })
  },
});

export const { addPdf, removeFirstPdf, clearPdf, removeFromFolderPdf,togglePinPdf } = pdfSlice.actions;

export default pdfSlice.reducer;
